import { render, staticRenderFns } from "./RevenueCategoryForm.vue?vue&type=template&id=1bbd99d2&scoped=true&"
import script from "./RevenueCategoryForm.vue?vue&type=script&lang=ts&"
export * from "./RevenueCategoryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd99d2",
  null
  
)

export default component.exports